<template>
  <Select 
    v-bind="$attrs"
    :value="value"
    @input="$emit('input', $event)"
  >
    <Option
      v-for="country in alphabeticalCountries" :key="country.code" :value="country.code">
      {{ country.emoji }} {{ country.name }}
    </Option>
  </Select>
</template>
<script>
import { countries } from 'countries-list'

export default {
  name: 'CountrySelect',

  props: {
    value: String
  },

  data() {
    return {
      countries
    }
  },

  computed: {
    countryObjects() {
      return Object.keys(this.countries).map((code) => ({ ...this.countries[code], code }))
    },

    alphabeticalCountries() {
      return this.countryObjects.sort((c1, c2) => (
        c1.name > c2.name ? 1 : (c2.name > c1.name ? -1 : 0)
      ))
    }
  }
}

</script>
